import { notice } from "@/components/Notification";
import { passwordkit } from "@/components/PasswordKit";
import { useSetState } from "ahooks";
import { Toast } from "antd-mobile";
export const PageExample = () => {
  const [state, setState] = useSetState({
    number: 0
  });
  return <>
      <button onClick={() => {
      passwordkit().then(text => Toast.show(text));
    }}>
        click it
      </button>
      <button onClick={() => setState(prev => ({
      number: prev.number + 1
    }))}>
        click increase {state.number}
      </button>
      <button onClick={() => {
      const data = {
        type: "WaitingSellerConfirm",
        content: "您有新的交易订单，请及时处理。 订单号：BUY202310061959203287 金额：33.00",
        data: {
          buyerId: 14,
          buyerType: "Member",
          amount: "33.00",
          paymentType: "1",
          buyerPaymentTypeId: "159",
          pendingOrderId: "308",
          businessFeeInfo: '{"buyerLevel":"","buyerFeeRate":0,"buyerId":14,"sellerLevel":"","sellerFeeRate":0,"sellerId":15}',
          pendingOrderNo: "PO202309051918470308",
          sellerId: 15,
          sellerType: "Business",
          sellerAdminId: 0,
          sellerPaymentTypeId: 138,
          createDate: "2023-10-06",
          status: "WaitingSellerConfirm",
          createTime: "2023-10-06 19:59:20",
          updateTime: "2023-10-06 19:59:20",
          orderId: 603287,
          orderNo: "BUY202310061959203287"
        },
        expire: 1696595360
      };
      notice({
        title: data.type,
        content: data.content
      });
    }}>
        notification
      </button>
    </>;
};